<div style="display: flex; justify-content: center; align-items: center; flex-direction: column;">

    <div class="overdiv">
        <div>
            <h1 [innerHTML]="dataJson['Ueberschrift']"></h1>
            <span [innerHTML]="dataJson['Block1Text1']"></span><br><br>
            <span [innerHTML]="dataJson['Block1Text2']"></span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; " [innerHTML]="dataJson['Block2Ueberschrift']"></span></h3>
            <span [innerHTML]="dataJson['Block2Text1']"></span><br><br>
            <span [innerHTML]="dataJson['Block2Text2']"></span><br><br>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; " [innerHTML]="dataJson['Block3Ueberschrift']"></span></h3>
            <span [innerHTML]="dataJson['Block3Text1']"></span><br><br>
            <span [innerHTML]="dataJson['Block3Text2']"></span>
            <span [innerHTML]="dataJson['Block3Text3']"></span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; " [innerHTML]="dataJson['block4Ueberschrift']"></span></h3>
            <span [innerHTML]="dataJson['Block4Text1']"></span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; " [innerHTML]="dataJson['Block5Ueberschrift']"></span></h3>
            <span [innerHTML]="dataJson['Block5Text1']"></span><br><br>
            <span [innerHTML]="dataJson['Block5Text2']"></span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; " [innerHTML]="dataJson['Block6Ueberschrift']"></span></h3>
            <span [innerHTML]="dataJson['Block6Text1']"></span><br><br>
            <span [innerHTML]="dataJson['Block6Text2']"></span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; " [innerHTML]="dataJson['Block7Ueberschrift']"></span></h3>
            <span [innerHTML]="dataJson['Block7Text1']"></span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; " [innerHTML]="dataJson['Block8Ueberschrift']"></span></h3>
            <span [innerHTML]="dataJson['Block8Text1']"></span>
            <span [innerHTML]="dataJson['Block8Text2']"></span>
        </div>
    </div>
    
    <app-contact-pre></app-contact-pre>
    <a aria-label="Zurück Button" class="backbutton" routerLink="/leistungen"> < </a>
    
    </div>
    